import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { EuiSwitch } from "@elastic/eui";
import CheckBoxWithComments from "components/checkBoxWithComments";
import CheckBox from "components/checkbox";
import { getPenaltiesAndDeductions } from "modules/clientProjects/api";
import { checkIsObjectEmpty } from "utils/checkEmptyValues";
import AccordionComponent from "../../../../components/accordion";
import { FormRow, FormGroup, Row } from "../../../../styles/forms/main";
import Input from "../../../../components/input";
import TextArea from "../../../../components/textArea";
import UploadAttachments from "../../../../components/uploadAttachments";

export const ProjectFinancialLegalBodyContainer = styled.div`
    padding: 15px 0;
    background-color: white;
    display: flex;
    flex-direction: column;
`;

const Label = styled.label`
    display: flex;
    font-size: 12px;
    font-weight: 400;
    color: #98a2b3;
    padding-bottom: 5px;
`;

export default function ProjectFinancialLegalForm({
    setFinancialLegal,
    projectFinancialLegal,
    isEditable,
    formIsValid,
    setSalesAttachments,
    setSupplierAttachments,
    userRole,
    isCreate,
    onDeleteUploadedItem,
    onDeleteAllAttachements,
    setTargetPriceAttachments,
    setAllIllaDeductions,
    setAllClientDeductions,
    allIllaDeductions,
    allClientDeductions,
    deductionsValues,
    setDeductionsValues,
}) {
    const ILLA_ID = "0";
    const CLIENT_ID = "1";
    const [hasotherDeductions, setHasOtherDeductions] = useState(false);

    const handleGetPenaltiesAndDeductions = async (partyId) => {
        const data = await getPenaltiesAndDeductions(partyId);
        if (partyId === "0") {
            setAllIllaDeductions(data);
        } else {
            setAllClientDeductions(data);
        }
    };
    useEffect(() => {
        if (projectFinancialLegal?.illaDeductions) {
            handleGetPenaltiesAndDeductions(ILLA_ID);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectFinancialLegal?.illaDeductions]);

    useEffect(() => {
        if (projectFinancialLegal?.clientDeductions) {
            handleGetPenaltiesAndDeductions(CLIENT_ID);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectFinancialLegal?.clientDeductions]);

    useEffect(() => {
        if (projectFinancialLegal?.specialPenaltiesAndDeductions) {
            setHasOtherDeductions(true);
        }
    }, [projectFinancialLegal]);

    const projectFinancialLegalBody = () => (
        <>
            <ProjectFinancialLegalBodyContainer>
                <FormRow>
                    <FormGroup>
                        <Input
                            key="collection"
                            type="number"
                            name="Client Collection"
                            required
                            label="Client Collection cycle  days"
                            value={projectFinancialLegal?.ClientCollection}
                            onChange={(e) =>
                                setFinancialLegal("ClientCollection", e?.target?.value)
                            }
                            min="1"
                            isEditable={
                                isEditable &&
                                (userRole === "sales" || userRole === "project_manager")
                            }
                            error={
                                isEditable &&
                                userRole === "sales" &&
                                !formIsValid &&
                                !projectFinancialLegal?.ClientCollection
                            }
                        />
                    </FormGroup>
                    <FormGroup>
                        <Input
                            key="invoicing"
                            type="number"
                            name="Invoicing cycle"
                            required
                            label="Invoicing cycle"
                            value={projectFinancialLegal?.invoicing}
                            onChange={(e) => setFinancialLegal("invoicing", e?.target?.value)}
                            min="1"
                            isEditable={
                                isEditable &&
                                (userRole === "sales" || userRole === "project_manager")
                            }
                            error={
                                isEditable &&
                                userRole === "sales" &&
                                !formIsValid &&
                                !projectFinancialLegal?.invoicing
                            }
                        />
                    </FormGroup>
                </FormRow>
                <FormRow>
                    <FormGroup>
                        <Input
                            key="pods"
                            type="number"
                            name="PODs collection"
                            required
                            label="PODs collection cycle days"
                            value={projectFinancialLegal?.PODs}
                            onChange={(e) => setFinancialLegal("PODs", e?.target?.value)}
                            min="1"
                            isEditable={
                                isEditable &&
                                (userRole === "sales" || userRole === "project_manager")
                            }
                            error={
                                isEditable &&
                                userRole === "sales" &&
                                !formIsValid &&
                                !projectFinancialLegal?.PODs
                            }
                        />
                    </FormGroup>
                </FormRow>
                <FormRow>
                    <FormGroup>
                        <EuiSwitch
                            label="Project has deductions & penalties to apply"
                            checked={projectFinancialLegal?.hasDeductions}
                            onChange={(e) => setFinancialLegal("hasDeductions", e?.target?.checked)}
                            disabled={
                                !(
                                    isEditable &&
                                    (userRole === "sales" || userRole === "project_manager")
                                )
                            }
                        />
                    </FormGroup>
                </FormRow>
                {projectFinancialLegal?.hasDeductions && (
                    <>
                        <FormRow>
                            <FormGroup>
                                <CheckBox
                                    label="ILLA"
                                    name="illa"
                                    details="Deductions & penalties"
                                    value={projectFinancialLegal?.illaDeductions}
                                    onChange={(e) =>
                                        setFinancialLegal("illaDeductions", e?.target?.checked)
                                    }
                                    borderd
                                    disabled={
                                        !(
                                            isEditable &&
                                            (userRole === "sales" || userRole === "project_manager")
                                        )
                                    }
                                    error={
                                        !formIsValid &&
                                        projectFinancialLegal?.illaDeductions &&
                                        checkIsObjectEmpty(deductionsValues)
                                    }
                                    required={
                                        projectFinancialLegal?.illaDeductions &&
                                        checkIsObjectEmpty(deductionsValues)
                                    }
                                />
                            </FormGroup>
                            <FormGroup>
                                <CheckBox
                                    label="Client"
                                    name="client"
                                    details="Deductions & penalties"
                                    value={projectFinancialLegal?.clientDeductions}
                                    onChange={(e) =>
                                        setFinancialLegal("clientDeductions", e?.target?.checked)
                                    }
                                    borderd
                                    disabled={
                                        !(
                                            isEditable &&
                                            (userRole === "sales" || userRole === "project_manager")
                                        )
                                    }
                                    error={
                                        !formIsValid &&
                                        projectFinancialLegal?.clientDeductions &&
                                        checkIsObjectEmpty(deductionsValues)
                                    }
                                    required={
                                        projectFinancialLegal?.clientDeductions &&
                                        checkIsObjectEmpty(deductionsValues)
                                    }
                                />
                            </FormGroup>
                        </FormRow>
                        <FormRow>
                            {projectFinancialLegal?.illaDeductions && (
                                <FormGroup>
                                    <CheckBoxWithComments
                                        options={allIllaDeductions}
                                        isEditable={
                                            isEditable &&
                                            (userRole === "sales" || userRole === "project_manager")
                                        }
                                        optionsValues={deductionsValues}
                                        setOptionsValues={setDeductionsValues}
                                        placeholder="Write your comment here"
                                    />
                                </FormGroup>
                            )}
                            {projectFinancialLegal?.clientDeductions && (
                                <FormGroup style={{ marginLeft: "auto" }}>
                                    <CheckBoxWithComments
                                        options={allClientDeductions}
                                        isEditable={
                                            isEditable &&
                                            (userRole === "sales" || userRole === "project_manager")
                                        }
                                        optionsValues={deductionsValues}
                                        setOptionsValues={setDeductionsValues}
                                        placeholder="Write your comment here"
                                    />
                                </FormGroup>
                            )}
                        </FormRow>
                        <FormRow>
                            <Label>Others</Label>
                            <Row>
                                <CheckBox
                                    label="Others"
                                    name="hasotherDeductions"
                                    onChange={(e) => {
                                        setHasOtherDeductions(e.target.checked);
                                        setFinancialLegal("specialPenaltiesAndDeductions", "");
                                    }}
                                    value={hasotherDeductions}
                                    borderd
                                    disabled={
                                        !(
                                            isEditable &&
                                            (userRole === "sales" || userRole === "project_manager")
                                        )
                                    }
                                />
                                {hasotherDeductions && (
                                    <TextArea
                                        type="text"
                                        name="others"
                                        label="Others"
                                        value={projectFinancialLegal?.specialPenaltiesAndDeductions}
                                        placeholder="Write your comment here"
                                        required
                                        isEditable={
                                            isEditable &&
                                            (userRole === "sales" || userRole === "project_manager")
                                        }
                                        onChange={(e) =>
                                            setFinancialLegal(
                                                "specialPenaltiesAndDeductions",
                                                e?.target?.value
                                            )
                                        }
                                    />
                                )}
                            </Row>
                        </FormRow>
                    </>
                )}

                <FormRow>
                    <FormGroup>
                        <UploadAttachments
                            label="Client Contract"
                            onFilesChange={(e) => {
                                setSalesAttachments(e);
                            }}
                            isEditable={
                                isCreate ||
                                ((userRole === "sales" || userRole === "project_manager") &&
                                    isEditable)
                            }
                            uploadedAttachments={projectFinancialLegal?.salesAttachments}
                            onDeleteUploadedItem={onDeleteUploadedItem}
                            onDeleteAllAttachements={onDeleteAllAttachements}
                        />
                    </FormGroup>
                    <FormGroup>
                        <UploadAttachments
                            label="Target price"
                            onFilesChange={(e) => {
                                setTargetPriceAttachments(e);
                            }}
                            isEditable={
                                isCreate ||
                                ((userRole === "sales" || userRole === "project_manager") &&
                                    isEditable)
                            }
                            uploadedAttachments={projectFinancialLegal?.targetPriceAttachments}
                            onDeleteUploadedItem={onDeleteUploadedItem}
                            onDeleteAllAttachements={onDeleteAllAttachements}
                        />
                    </FormGroup>
                </FormRow>
            </ProjectFinancialLegalBodyContainer>

            {!isCreate && (
                <ProjectFinancialLegalBodyContainer>
                    <FormRow>
                        {(userRole === "supplier" ||
                            userRole === "project_manager" ||
                            projectFinancialLegal?.supplyPaymentCycleDays) && (
                            <FormGroup>
                                <Input
                                    key="cycle"
                                    type="number"
                                    name="payment cycle days"
                                    required
                                    label="Supply payment cycle days"
                                    value={projectFinancialLegal?.supplyPaymentCycleDays}
                                    onChange={(e) =>
                                        setFinancialLegal(
                                            "supplyPaymentCycleDays",
                                            e?.target?.value
                                        )
                                    }
                                    min="1"
                                    max="30"
                                    isEditable={
                                        isEditable &&
                                        (userRole === "supplier" || userRole === "project_manager")
                                    }
                                    error={
                                        !formIsValid &&
                                        userRole === "supplier" &&
                                        !projectFinancialLegal?.supplyPaymentCycleDays
                                    }
                                />
                            </FormGroup>
                        )}
                        {(userRole === "supplier" ||
                            userRole === "project_manager" ||
                            projectFinancialLegal?.supplyReviewCycle) && (
                            <FormGroup>
                                <Input
                                    key="review"
                                    type="number"
                                    name="reconciliation"
                                    required
                                    label="Supply reconciliation/review cycle "
                                    value={projectFinancialLegal?.supplyReviewCycle}
                                    onChange={(e) =>
                                        setFinancialLegal("supplyReviewCycle", e?.target?.value)
                                    }
                                    min="1"
                                    isEditable={
                                        isEditable &&
                                        (userRole === "supplier" || userRole === "project_manager")
                                    }
                                    error={
                                        !formIsValid &&
                                        userRole === "supplier" &&
                                        !projectFinancialLegal?.supplyReviewCycle
                                    }
                                />
                            </FormGroup>
                        )}
                    </FormRow>

                    <FormRow>
                        <UploadAttachments
                            label="Suppliers contracts"
                            onFilesChange={(e) => {
                                setSupplierAttachments(e);
                            }}
                            isEditable={
                                isCreate ||
                                ((userRole === "supplier" || userRole === "project_manager") &&
                                    isEditable)
                            }
                            uploadedAttachments={projectFinancialLegal?.supplyAttachments}
                            onDeleteUploadedItem={onDeleteUploadedItem}
                            onDeleteAllAttachements={onDeleteAllAttachements}
                        />
                    </FormRow>
                </ProjectFinancialLegalBodyContainer>
            )}
        </>
    );
    return (
        <AccordionComponent
            title="Project Financial & Legal Details"
            body={projectFinancialLegalBody()}
            defaultExpanded
            id="financial"
        />
    );
}
